'use client';

import type { FC } from 'react';
import { EventType } from '@/services/isomorphic/UserInteractionService';
import { Link } from '@/react/components/core-ui/Link';
import { useDrawerActions } from '@/react/components/core-ui/Drawer/hooks';
import { classes } from '@/next-utils/css-utils/scss-utils';
import { INavigationLinkProps } from './INavigationLinkProps';
import { MobileDrawer } from '../MobileDrawer';
import { MobileNavItem } from '../MobileNavItem';

import S from '../../styles.base.module.scss';

/**
 * Navigation item for use when specifying nav structure via config.
 */
export const NavigationLink: FC<INavigationLinkProps> = ({ item }) => {
  const { closeAllDrawers } = useDrawerActions();

  return (
    <div className={S.columnFullWidth}>
      <Link
        className={classes(S.navLink, S.mainLink)}
        href={`${item.href}`}
        onClick={closeAllDrawers}
        interactionDetails={{
          action: EventType.NavigationLink,
          link: {
            linkName: item.name,
            linkCategory: 'top-navigation',
            linkSection: item.name
          }
        }}
      >
        {item.name}
      </Link>

      <ul className={S.navList}>
        {item.categories?.map((category) => (
          <MobileDrawer key={category.id} label={category.name}>
            <MobileNavItem>
              <div className={S.columnFullWidth}>
                <Link
                  className={classes(S.navLink, S.mainLink)}
                  href={`${category.href}`}
                  onClick={closeAllDrawers}
                  interactionDetails={{
                    action: EventType.NavigationLink,
                    link: {
                      linkName: category.name,
                      linkCategory: 'top-navigation',
                      linkSection: category.name
                    }
                  }}
                >
                  {category.name}
                </Link>

                <ul className={S.navList}>
                  {category.categories?.map((subCategory) => (
                    <MobileNavItem key={subCategory.id}>
                      <Link
                        className={classes(S.navLink, S.subLink)}
                        href={`${subCategory.href}`}
                        onClick={closeAllDrawers}
                        interactionDetails={{
                          action: EventType.NavigationLink,
                          link: {
                            linkName: subCategory.name,
                            linkCategory: 'top-navigation',
                            linkSection: subCategory.name
                          }
                        }}
                      >
                        {subCategory.name}
                      </Link>
                    </MobileNavItem>
                  ))}
                </ul>
              </div>
            </MobileNavItem>
          </MobileDrawer>
        ))}
      </ul>
    </div>
  );
};
